const MyPurchasedToyList_query = `query{
  myPurchasedToyList{
    toyId{
      uuid
      title
      sellingPrice
      originalPrice
      createDate
      publishedDate
      status
      ratingNo
      toyImages
      {
        toyImageId
        fileName
      }

    }
    orderDate
  }
}`;
const MyToyList_query = `query{
  myToyList{
    toyId
    uuid
    title
    sellingPrice
    originalPrice
    createDate
    publishedDate
    status
    ratingNo
    toyImages
    {
      toyImageId
      fileName
    }
    toyLikes{
      toyLikeId
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
    }
  }
}`;
const ToyListByUserUuid_query = `query($userUuid: String!){
  toyListByUseruuid(userUuid: $userUuid){
    toyId
    title
    sellingPrice
    originalPrice
    createDate
    publishedDate
    isLiked
    categoryId{
     title
    }
    subCategoryId{
    title 
    }
    toyImages
    {
      toyImageId
      fileName
    }
    toyLikes{
      toyLikeId
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
    }
    toyComments{
      uuid
      toyCommentId
      content
      likeNo
      isLiked
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
      replies{
        uuid
        userId
        {
          username
          avatarFileName
          isLoggedInUserFollowing
        }
        content
        toyCommentId{
          toyCommentId
        }
        likeNo
        isLiked
        createBy
        createDate
        updateDate
        updateBy
      }
      createBy
      createDate
      updateBy
      updateDate
    }
  }
}`;

const ToyDetailByUuid_query = `query ToyDetailByUuid($toyUuid: String!) {
  toyDetailByUuid(uuid: $toyUuid){
    toyId
    title
    description
    sellingPrice
    originalPrice
    likeNo
    commentNo
    shareNo
    dimension
    weight
    noOfPlayers
    batteryRequired
    batteryIncluded
    assemblyRequired
    gameDuration
    publishedDate
    status
    isPublished
    isLiked
	  isInCollection
    userId{
      userUuid
      username
      firstName
      lastName
      ratingNo
      ratingCount
      activationDate
      avatarFileName
      dateJoined
      isLoggedInUserFollowing
    }
    toyComments{
      uuid
      toyCommentId      
      content
      likeNo
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
      isLiked
      replies{
        uuid
        userId
        {
          username
          avatarFileName
          isLoggedInUserFollowing
        }
        content
        toyCommentId{
          toyCommentId
        }
        likeNo
        isLiked
        createBy
        createDate
        updateDate
        updateBy
      }
      createBy
      createDate
      updateBy
      updateDate
    }

    toyLikes{
      toyLikeId
      userId{
        username
        avatarFileName
        isLoggedInUserFollowing
      }
    }
    
    toyImages{
      fileName
    }

    toyTags{
      tagId{
        title
      }
    }

    brandId{
      title
    }
    categoryId{
      title
    }
    subCategoryId{
      title
    }
    conditionId{
      title
    }
    warningId{
      title
    }
    ageGroupId{
      title
    }
    materialId{
      title
    }
    colorId{
      title
    }
    subColorId{
      title
    }
    difficultyId{
      title
    }
    warningId{
      title
    }
    manufacturerCountryId{
      name
    }
  }
}`;

const UpdateToyDataByUuid_mutate = `mutation UpdateToyByUuid($toyUuid: String!,
  $updateVals: ToyUpdateData!) {
    updateToyByUuid(toyUuid: $toyUuid, updateVals: $updateVals) {
      success
    }
  }
`;

const UpdateToyImagesByUuid_mutate = `mutation UpdateToyImagesByUuid($toyUuid: String!,
  $imagesData: [ToyImageUpdateInput!]!) {
    updateToyImagesByUuid(toyUuid: $toyUuid, imagesData: $imagesData) {
      success
    }
  }
`;

const UpdateToyShareNoByUuid_mutate = `mutation UpdateToyShareNoByUuid(
  $toyUuid: String!) {
    updateToyShareNoByUuid(
      toyUuid: $toyUuid) {
      success
    }
  }
`;

const CreateToyLike_mutate = `
  mutation createToyLike(
    $toyUuid: String!,     
  ) {
    createToyLike(
      toyUuid: $toyUuid,        
    ) {        
      toyLike
        {
          uuid
          userId
          {
            id
            username            
          }
          toyId
          {
            toyId
            title           
          }
        }
      }
    }
`;

const DeleteToyLike_mutate = `
  mutation deleteToyLike(
    $toyUuid: String!     
  ) {
    deleteToyLike(
      toyUuid: $toyUuid        
      ) {        
      response
    }
  }
`;

const DeleteToyByUuid_mutate = `mutation deleteToyByUuid($toyUuid: String!) {
    deleteToyByUuid(toyUuid: $toyUuid) {
      success
      msg
    }
  }
`;

const CreateToyComment_mutate = `
  mutation createToyComment(
    $toyUuid: String!,
    $content: String!,     
  ) {
    createToyComment(
      toyUuid: $toyUuid,
      content: $content,         
    ) {        
      toyComment
        {
          uuid
          userId
          {
            id
            username
            avatarFileName            
          }
          toyId
          {
            toyId
            title           
          }
          title
          content
          likeNo
          createBy
          createDate
          updateBy
          updateDate
        }
      }
    }
`;

const DeleteToyComment_mutate = `
  mutation deleteToyComment(
    $toyCommentUuid: String!,      
  ) {
    deleteToyComment(
      toyCommentUuid: $toyCommentUuid,       
      ) {        
      response
    }
  }
`;

const EditToyComment_mutate = `
    mutation editToyComment(
      $toyCommentUuid: String!,
      $content: String!,      
    ) {
      editToyComment(
        toyCommentUuid: $toyCommentUuid,
        content: $content) {        
        toyComment
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          toyCommentId
          userId
          {
            username
          }
          toyId
          {
            uuid
          }
          title
          content          
          likeNo
        }
      }
    }
`;

const AllToysList_query = `query{
  allToys{
    toyId
    uuid
    title
    publishedDate
    isPublished
    createDate
    status
    userId{
      userUuid
      username
    }
    toyImages{
      fileName
    }
  }
}`;

const CreateToyCommentLike_mutate = `
  mutation createToyCommentLike(
    $toyCommentUuid: String!,     
  ) {
    createToyCommentLike(
      toyCommentUuid: $toyCommentUuid,        
    ) {        
      toyCommentLike
        {
          uuid
          userId
          {
            id
            username            
          }
          toyCommentId
          {
            toyCommentId
            title           
          }
        }
      }
    }
`;

const DeleteToyCommentLike_mutate = `
  mutation deleteToyCommentLike(
    $toyCommentUuid: String!     
  ) {
    deleteToyCommentLike(
      toyCommentUuid: $toyCommentUuid        
      ) {        
      response
    }
  }
`;

const CreateToyCommentReply_mutate = `
  mutation createToyCommentReply(
    $toyCommentUuid: String!,
    $content: String!,     
  ) {
    createToyCommentReply(
      toyCommentUuid: $toyCommentUuid,
      content: $content,         
    ) {        
      toyCommentReply
        {
          uuid
          userId
          {
            id
            username
            avatarFileName            
          }
          toyCommentId
          {
            toyCommentId
            title
            content           
          }
          content
          likeNo
          createBy
          createDate
          updateBy
          updateDate
        }
      }
    }
`;

const DeleteToyCommentReply_mutate = `
  mutation deleteToyCommentReply(
    $toyCommentReplyUuid: String!,      
  ) {
    deleteToyCommentReply(
      toyCommentReplyUuid: $toyCommentReplyUuid,       
      ) {        
      response
    }
  }
`;

const EditToyCommentReply_mutate = `
    mutation editToyCommentReply(
      $toyCommentReplyUuid: String!,
      $content: String!,      
    ) {
      editToyCommentReply(
        toyCommentReplyUuid: $toyCommentReplyUuid,
        content: $content) {        
        toyCommentReply
        {
          createBy
          createDate
          updateDate
          updateBy
          uuid
          toyCommentReplyId
          userId
          {
            username
          }
          toyCommentId
          {
            uuid
            title
            content
          }
          content          
          likeNo
        }
      }
    }
`;

const CreateToyCommentReplyLike_mutate = `
  mutation createToyCommentReplyLike(
    $toyCommentReplyUuid: String!,     
  ) {
    createToyCommentReplyLike(
      toyCommentReplyUuid: $toyCommentReplyUuid,        
    ) {        
      toyCommentReplyLike
        {
          uuid
          userId
          {
            id
            username            
          }
          toyCommentReplyId
          {
            toyCommentReplyId
            content           
          }
        }
      }
    }
`;

const DeleteToyCommentReplyLike_mutate = `
  mutation deleteToyCommentReplyLike(
    $toyCommentReplyUuid: String!     
  ) {
    deleteToyCommentReplyLike(
      toyCommentReplyUuid: $toyCommentReplyUuid        
      ) {        
      response
    }
  }
`;

module.exports = {
  MY_TOY_LIST: MyToyList_query,
  MY_PURCHASED_TOY_LIST: MyPurchasedToyList_query,
  TOY_LIST_BY_USER_UUID: ToyListByUserUuid_query,
  TOY_DETAIL_BY_UUID: ToyDetailByUuid_query,
  UPDATE_TOY_DATA_BY_UUID: UpdateToyDataByUuid_mutate,
  UPDATE_TOY_IMAGES_BY_UUID: UpdateToyImagesByUuid_mutate,
  UPDATE_TOY_SHARE_NO_BY_UUID: UpdateToyShareNoByUuid_mutate,
  CREATE_TOY_LIKE_MUTATION: CreateToyLike_mutate,
  DELETE_TOY_LIKE_MUTATION: DeleteToyLike_mutate,
  DELETE_TOY_DATA_BY_UUID: DeleteToyByUuid_mutate,
  CREATE_TOY_COMMENT_MUTATION: CreateToyComment_mutate,
  DELETE_TOY_COMMENT_MUTATION: DeleteToyComment_mutate,
  EDIT_TOY_COMMENT_MUTATION: EditToyComment_mutate,
  ALL_TOYS_LIST: AllToysList_query,
  CREATE_TOY_COMMENT_LIKE_MUTATION: CreateToyCommentLike_mutate,
  DELETE_TOY_COMMENT_LIKE_MUTATION: DeleteToyCommentLike_mutate,
  CREATE_TOY_COMMENT_REPLY_MUTATION: CreateToyCommentReply_mutate,
  DELETE_TOY_COMMENT_REPLY_MUTATION: DeleteToyCommentReply_mutate,
  EDIT_TOY_COMMENT_REPLY_MUTATION: EditToyCommentReply_mutate,
  CREATE_TOY_COMMENT_REPLY_LIKE_MUTATION: CreateToyCommentReplyLike_mutate,
  DELETE_TOY_COMMENT_REPLY_LIKE_MUTATION: DeleteToyCommentReplyLike_mutate,
};
